import React from "react";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {RouteDefine} from "../../../../routes/RouteDefine";

type SettingsPageHeaderProps = {
    title: string;
    subtitle?: string;
    actions?: React.ReactNode;
    showBackToDashboard?: boolean;
};

const SettingsPageHeader: React.FC<SettingsPageHeaderProps> = ({
    title,
    subtitle,
    actions,
    showBackToDashboard = false,
}) => {
    const {t} = useTranslation();

    return (
        <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <div>
                    {showBackToDashboard ? (
                        <Link
                            to={RouteDefine.dashboard}
                            className="small text-muted text-decoration-none d-inline-flex align-items-center mb-1"
                        >
                            <i className="las la-arrow-left me-1"/>
                            {t("common.settings.backToDashboard")}
                        </Link>
                    ) : null}
                    <div className="page-title-name">{title}</div>
                    {subtitle ? (
                        <p className="text-muted mb-0 small mt-1">{subtitle}</p>
                    ) : null}
                </div>
                {actions ? (
                    <div className="page-title-right d-flex flex-column flex-sm-row align-items-sm-center gap-2">
                        {actions}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default React.memo(SettingsPageHeader);
